<div
  data-test="6kpbXqiy"
  class="label label_blue"
  (click)="showDropdown = !showDropdown"
  data-dropdown="#dd-header-label"
>
  <span data-test="3cnaIdEd">{{ label }}</span>
  <i data-test="otuglsLi" class="material-icons md-12">keyboard_arrow_down</i>
</div>
<div
  data-test="NF_L6OmJ"
  class="dropdown dropdown_bottom-right dropdown_arrow show"
  #scrollElem
  [class.active]="showDropdown"
  id="dd-header-label"
>
  <div data-test="2zCoQBht" class="dropdown__wrap">
    <ul data-test="C0RTPaRH" class="dropdown__menu" #listElem>
      <li
        data-test="zvDzSEb6"
        class="dropdown__menu-item"
        [class.checked]="isChosen(option)"
        *ngFor="let option of options"
      >
        <a data-test="aOxVw16D" class="dropdown__menu-link" (click)="selectValue(option)">
          {{ labelKey ? option[labelKey] : option }}
        </a>
      </li>
    </ul>
  </div>
</div>
